import { CircularProgress, Box } from "@mui/material";

const Loader = () => (
  <Box
    position="fixed"
    top={0}
    left={0}
    width="100vw"
    height="100vh"
    display="flex"
    justifyContent="center"
    alignItems="center"
    bgcolor="rgba(210, 222, 222, 0.57)" // Optional: semi-transparent background
    zIndex={1300} // Higher than most MUI components
  >
    <CircularProgress />
  </Box>
);

export default Loader;
